var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parent"},[_c('lab',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('steps',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path.startsWith('/parent')),expression:"$route.path.startsWith('/parent')"}],attrs:{"mod":_vm.mod}})]},proxy:true}])}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }